const RankStarHalfOrange = ({ className }: { className: string }) => (
  <svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
    <defs>
      <clipPath id="halfStar">
        <rect x="0" y="0" width="8" height="16" />
      </clipPath>
    </defs>
    <path
      fill="#ffbf66"
      d="m9 11.3 3.71 2.7-1.42-4.36L15 7h-4.55L9 2.5 7.55 7H3l3.71 2.64L5.29 14 9 11.3z"
      clipPath="url(#halfStar)"
      className="color000000 svgShape"
    />
    <path
      stroke="#ffbf66"
      strokeWidth="1.5"
      fill="none"
      d="m9 11.3 3.71 2.7-1.42-4.36L15 7h-4.55L9 2.5 7.55 7H3l3.71 2.64L5.29 14 9 11.3z"
      className="color000000 svgShape"
    />
  </svg>
);

export default RankStarHalfOrange;
